import { render, staticRenderFns } from "./ProductCategoryOptionsDialog.vue?vue&type=template&id=3c197c4e&scoped=true&"
import script from "./ProductCategoryOptionsDialog.vue?vue&type=script&lang=ts&"
export * from "./ProductCategoryOptionsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCategoryOptionsDialog.vue?vue&type=style&index=0&id=3c197c4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c197c4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VCardText,VCheckbox,VCol,VLayout,VRow,VTextField})
